import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '';

export default function BoxOfficeDataPage() {
  const [allTimeMovies, setAllTimeMovies] = useState([]);
  const [currentYearMovies, setCurrentYearMovies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [boxOfficeTab, setBoxOfficeTab] = useState('allTime'); // 'allTime' or 'currentYear'

  useEffect(() => {
    fetchBoxOfficeData();
  }, []);

  const fetchBoxOfficeData = async () => {
    try {
      setLoading(true);
      setError('');
      const res = await axios.get(`${API}/api/boxoffice`);
      setAllTimeMovies(res.data.allTime || []);
      setCurrentYearMovies(res.data.currentYear || []);
    } catch (err) {
      setError('Failed to load box office data');
    } finally {
      setLoading(false);
    }
  };

  const formatBoxOffice = (boxOffice) => {
    if (!boxOffice) return 'N/A';
    const num = typeof boxOffice === 'number' ? boxOffice : parseFloat(boxOffice);
    if (isNaN(num)) return boxOffice;
    return `₹${(num / 10000000).toFixed(2)} Cr`;
  };

  if (loading) {
    return (
      <div className="box-office-data-page">
        <div className="loading-indicator">Loading box office data...</div>
      </div>
    );
  }

  return (
    <div className="box-office-data-page">
      <h1 className="page-title">Box Office Collections</h1>
      {error && <div className="error-message">{error}</div>}

      <div className="box-office-tabs">
        <button
          className={`box-office-tab ${boxOfficeTab === 'allTime' ? 'active' : ''}`}
          onClick={() => setBoxOfficeTab('allTime')}
        >
          Top 10 All Time
        </button>
        <button
          className={`box-office-tab ${boxOfficeTab === 'currentYear' ? 'active' : ''}`}
          onClick={() => setBoxOfficeTab('currentYear')}
        >
          Top 10 This Year
        </button>
      </div>

      <div className="boxoffice-table">
        <div className="boxoffice-header">
          <div className="rank">Rank</div>
          <div className="title">Movie Title</div>
          <div className="boxoffice">Box Office Collection</div>
        </div>
        {(boxOfficeTab === 'allTime' ? allTimeMovies : currentYearMovies).length > 0 ? (
          (boxOfficeTab === 'allTime' ? allTimeMovies : currentYearMovies).map((movie, idx) => (
            <div key={movie.id} className="boxoffice-row">
              <div className="rank">#{idx + 1}</div>
              <div className="title">{movie.title}</div>
              <div className="boxoffice">{formatBoxOffice(movie.boxOffice)}</div>
            </div>
          ))
        ) : (
          <div style={{ padding: 16, color: '#666' }}>No data available</div>
        )}
      </div>
    </div>
  );
}

